import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, CircularProgress, IconButton, Stack, Divider, Typography, Backdrop, TextField, Autocomplete } from '@mui/material';
import { Add, Close, Edit } from '@mui/icons-material';
import { Context } from '../../App';
import BilletInfoSection from '../forms/GuichetBillet';
import { useMemo } from 'react';


export default function CmdAddForm({ event, close, manage_snackbar, addCommande }) {
    const { setIsConnected } = useContext(Context);
    const agent = JSON.parse(sessionStorage.getItem('user'));

    const providers = ['sumup', 'stripe']
    const modes = ['cb', 'chèque', 'espèces', 'virement'];

    const [load, setLoad] = useState(false);
    const [statut, setStatut] = useState('');
    const [userId, setUser] = useState(agent?._id || '');
    const [users, setUsers] = useState([]);
    const [billets, setBillets] = useState([]);
    const [mail, setMail] = useState('');
    const [txCode, setTxCode] = useState('');
    const [mode, setMode] = useState('');

    const total = useMemo(()=> billets.reduce((tt, item) => tt + (item.price || 0), 0), [billets]);
    const user = useMemo(() => [...users, agent].find(u => u._id === userId), [users, userId]);

    function getUsers() {
        if (users.length > 1) return;
        setLoad(true);
        fetch(process.env.REACT_APP_API_URL + '/users', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.ok) {
                    const json = await response.json();
                    setUsers(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching users:", error);
        }).finally(() => {
            setLoad(false);
        });
    }

    const getBilletState = () => {
        switch (statut) {
            case 'En attente':
                return 'en attente paiement';
            case 'Payée':
                return 'valide';
            default:
                return ''
        }
    }

    function handleAddTicket() {
        if (!event) {
            setLoad(true);
            fetch(process.env.REACT_APP_API_URL + '/events', {method:'POST', headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({statut: {$nin: ['terminé', 'annulé']}})
            })
            .then(async response => {
                const token = response.headers.get('x-auth-token');
                if (response.status === 401) {
                    sessionStorage.clear();
                    setIsConnected(false);
                } else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                    }
                    if (response.ok) {
                        const json = await response.json();
                        // setEvents(json);
                    }
                }
            }).catch(error => {
                console.error("Error fetching events:", error);
            }).finally(() => {
                setLoad(false);
            });
        }

        setBillets([...billets, {
            owner: {
                id: user,
                nom: '',
                prenom: '',
            },
            event:'',
            price: 0, //prix du billet
            tarif: '', //tarif du billet
            statut: getBilletState(),
            by: agent?._id || ''
        }]);
    }

    function handleSubmit(e) {
        e.preventDefault();
        setLoad(true);

        const commande = {
            user,
            items: billets,
            statut,
            payments: statut === 'Payée' ? [{
                txCode,
                provider: providers.includes(mode) ? mode : '',
                montant: total,
                status: 'Payée',
                mode
            }] : [],
            by: agent?._id || ''
        }
        
        fetch(process.env.REACT_APP_API_URL + '/commandes/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify(commande)
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.ok) {
                    const json = await response.json();
                    addCommande(json);
                    manage_snackbar(true, "Commande créée avec succès");
                    close();
                } else {
                    manage_snackbar(true, "Erreur serveur lors de la création de la commande");
                }
            }
        }).catch(error => {
            console.error("Error fetching commandes:", error);
        }).finally(() => {
            setLoad(false);
        });
    }

    useEffect(()=>{
        setBillets(billets.map(b => ({ ...b, statut: getBilletState() })));
    }, [statut])

    useEffect(() => getUsers(), []);

    return (
        <Box component='form' onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', padding: 2 }}>
            <Typography variant="h4" sx={{ color: 'focus', textAlign:'center', mb: 4 }}>Création billets</Typography>

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems='center'>
                <Autocomplete
                    fullWidth
                    options={users.map(u => ({label: u.prenom + ' ' + u.nom, value: u._id}))}
                    onChange={(event, value) => setUser(value?.value || '')}
                    renderInput={(params) => <TextField {...params} label="Rechercher un client" size='small' />}
                />
                <Typography fontWeight={500} sx={{whiteSpace: 'nowrap'}}> ou Email: </Typography>
                <TextField fullWidth type='email' autoComplete='email' value={mail} onChange={(e) => setMail(e.target.value)} size='small' sx={{minWidth:'250px'}}/>
            </Stack>

            <Typography variant='subtitle1' sx={{ marginTop: 2, textAlign: 'center' }}>Billets</Typography>
            {billets.map((billet, index) => 
                !!billet && <BilletInfoSection key={index} {...{billet, event, index, setBillet:bl=>setBillets(old=> old.map((b, i)=>i===index ? bl : b)), rmBillet:()=>setBillets(old=>old.filter((b, i)=>i!==index))}} />
            )}

            <Button startIcon={<Add/>} onClick={handleAddTicket} sx={{mb:2, alignSelf:'center'}}>Ajouter un billet</Button>

            <Divider sx={{ width: '60%', alignSelf:'center', mb:1}}/>
            <Typography variant='h5' align='center' sx={{mb:2}}>Total et paiement</Typography>

            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent:{ xs: 'flex-start', md:'space-between'}, alignItems: 'center', mb: 2 }}> 
                <Typography variant='subtitle1'>Total: {total.toFixed(2)}</Typography>
                
                <TextField select label="Statut" variant="outlined" value={statut} required slotProps={{select: {native: true}, inputLabel:{shrink: true}}}
                sx={{ minWidth: '200px', width: 'auto', alignSelf:{ xs: 'stretch', md: 'end' }, mb:2 }}
                onChange={(e) => {if(e.target.value==='En attente')setMode(''); setStatut(e.target.value)}} size='small'>
                    <option value="" disabled={true}>Sélectionner un status</option>
                    <option value="En attente">En attente</option>
                    <option value="Payée">Payée</option>
                </TextField>
            </Box>

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems='center'>
                {statut === "Payée" && (
                    <TextField select label="Mode de paiement" value={mode} required onChange={(e) => setMode(e.target.value)} sx={{ width:'auto', minWidth:'200px'}} 
                    slotProps={{select: {native: true}, inputLabel:{shrink: true}}} size='small'>
                        <option value="" disabled={true}>Sélectionner un mode de paiement</option>
                        {[...providers, ...modes].map((md, index)=> <option key={index} value={md}>{md}</option>)}
                    </TextField>
                )}

                {providers.includes(mode) && (
                    <TextField type='text' label="Code de transaction" value={txCode} onChange={(e) => setTxCode(e.target.value)} size='small'
                    sx={{ minWidth:'200px'}} fullWidth/>
                )}
            </Stack>

            <Stack direction="row" spacing={2} sx={{ marginTop: 2, alignSelf: 'center' }}>
                <Button variant="outlined" color="focus" onClick={close}>Annuler</Button>
                <Button variant="contained" color="focus" disabled={billets.length===0} type="submit" sx={{color: 'white'}}>Enregistrer</Button>
                
            </Stack>

            <Backdrop open={load}><CircularProgress /></Backdrop>
        </Box>
    );
}